export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-07.jpg'),
        title: '企業向けアプリケーション',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '専門的で効率的な企業向けソフトウェア、ビジネス機会の獲得を支援',
      description: `<p style="font-size:1.05rem">ビジネスアプリケーションは、商業組織や大企業向けに設計されたソリューションとアプリケーションです。エンタープライズクラスのアプリケーションは、大量のユーザー、大量データ、高頻度トランザクションなどを扱う特徴があり、将来の業務要件の変化に対応しやすく、アップグレードや保守が容易です。高度で効率的なエンタープライズソフトウェアは、インダストリー4.0時代において運用コストを節減し、業務効率を向上させることで競争優位をもたらします。大量データの保管、大規模なGUI、複雑なビジネスロジックに対応するため、高度で安定したシステム性能が求められます。</p>`
    },
    {
      title: '私たちが提供できること',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-07.jpg')+`)"></span>
      <span>インターネットの発展に伴い、従来の分散コンピューティング技術ではサプライチェーン環境下の企業アプリケーションの要件を十分に満たせなくなりました。インターネットベースのサービス指向、コンポーネント呼び出し、クロスプラットフォーム要件に対応するため、Webサービスなどの次世代分散オブジェクト技術が求められています。MaesInfoは専門的で経験豊富な開発チームを有し、これらのサービス技術を提供します。お客様と緊密に連携し、エンタープライズアプリケーションの特性に合わせた継続的デリバリーとアジャイル開発の導入を支援します。</span>`
    }
  ]
}
